import { Injectable, OnDestroy } from '@angular/core'
import { AuthStorageService, AuthToken } from '@spartacus/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class MpupAuthorizationService implements OnDestroy {

  private authToken!: AuthToken
  private unsubscribe$ = new Subject<void>()

  constructor (private authStorageService: AuthStorageService, private http: HttpClient) {
    this.authStorageService.getToken()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (token) => this.authToken = token
      })
  }

  ngOnDestroy () {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  authorizedRequest<T> (endpoint: string, options = {}) {
    return this.http.get<T>(endpoint, {
      ...options,
      headers: {
        // @ts-ignore The JWT token does exists - only the spartacus token type doesn't define it
        'JWT-Tok-X': this.authToken.id_token,
        'Acc-Tok-X': this.authToken.access_token
      }
    })
  }
}
